import React, { useState, useEffect, useContext } from "react";
import {
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Button,
} from "@mui/material";
import {
  ModeEditOutlineOutlined,
} from "@mui/icons-material";
import SimpleModal from "../../../components/SimpleModal";
import blogFetch from "../../../axios/config";
import AsyncSelect from "react-select/async";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import toast from "react-hot-toast";
import { DateTimeFmt } from "../../../utils/DataUtils";
import UpdateOutstandingPieces from "./components/UpdateOutstandingPieces";
import { statusColor } from "../../../utils/statusColor";
import pendencyData from "./nls/pt-BR.json";
import language from "../../../nls/language.json";
import "./styles/OutstandingPieces.css";
import "../../../styles/Style.css";
import Context from "../../../context/Context";

const INITIAL_MODAL = {
  isShow: false,
  title: "",
  body: ""
}

function OutstandingPieces({ setCode }) {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [isGetPendencias, setIsGetPendencias] = useState(false);
  const [showModal, setShowModal] = useState(INITIAL_MODAL);
  const [updatePendancy, setUpdatePendancy] = useState({});
  const [sectorStates, setSectorStates] = useState({ name: "" });

  const {
    selectedCountry
  } = useContext(Context);

  useEffect(() => {
    if (!showModal.isShow)
      setUpdatePendancy({})
  }, [showModal.isShow]);

  useEffect(() => {
    if (Object.keys(updatePendancy).length)
      setShowModal({
        isShow: true,
        body: bodyEditPendencias(updatePendancy),
        title: language[selectedCountry.name].Dashboard.pecasPendentes.modal.editar.title
      })
  }, [updatePendancy]);

  const setDataPendencias = async (httpRequetType, link, params) => {
    try {
      setIsGetPendencias(true);
      setLoading(true);
      const { data } = await blogFetch[httpRequetType](link);
      console.log(data);
      setData(data)

    } catch (error) {
      console.error(error);
    }
    finally {
      setLoading(false);
    }
  }

  const getPendenciasBySector = async (sector = sectorStates) => {

    
    if (sector.setResp_nome)
      setSectorStates(sector)

    setDataPendencias('get', `/ISAGA_Pendencias/setor/${sector.setResp_nome}`);
  }

  const hangleStatusPendencias = async (pendencia) => {
    try {
      const { data } = await blogFetch
        .put(`/ISAGA_Pendencias/${pendencia.pend_Key}`, pendencia);
      setData(data)
      setLoading(true)
      setShowModal(INITIAL_MODAL);
      setUpdatePendancy({});
      toast.success(pendencyData.pendency.update.success, {
        duration: 4000,
      });
    } catch (error) {
      toast.error(pendencyData.pendency.update.error, {
        duration: 4000,
      });
    }
    finally{
      setLoading(false)
    }
  }

  const GetMotivosByDistinctSector = async () => {
    try {
      const { data } = await blogFetch.get("/ISAGA_PendenciasSetorResponsavel");

      console.log(data)
      return data;
    } catch (error) {
      console.error(error);
    }
  };

  const getHeader = async (order) => {
    try {
      setLoading(true);
      const response = await blogFetch.get(`/SAGAViewFichaCabecalho/${order}`);
      return response.data[0];
    } catch (error) {
      console.error(error);
      return null;
    }
    finally {
      setLoading(false);
    }
  };

  const handleUpdatePendency = ({ name, value }) => {
    setUpdatePendancy({
      ...updatePendancy,
      [name]: value
    });
  }

  const bodyEditPendencias = (item) => {
    return (
      <UpdateOutstandingPieces
        pendency={item}
        hangleStatusPendencias={hangleStatusPendencias}
        handleUpdatePendency={handleUpdatePendency}
        loading={loading}
      />
    )
  }

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <SimpleModal
        isShow={showModal.isShow}
        title={showModal.title}
        body={showModal.body}
        INITIAL_MODAL={INITIAL_MODAL}
        setShowModal={setShowModal}
      />
      <div className="header_tables_view">
        <div></div>
        <div>
          <h3 className="title_tables d-flex align-items-center flex-column">
            {language[selectedCountry.name].Dashboard.pecasPendentes.titulo}
          </h3>
          <AsyncSelect
            className="mb-3 w-80"
            styles={{ textAlign: "center" }}
            cacheOptions
            defaultOptions
            placeholder="Selecionar Setor"
            getOptionLabel={(e) => e.setResp_nome}
            getOptionValue={(e) => e.setResp_nome}
            loadOptions={GetMotivosByDistinctSector}
            onChange={getPendenciasBySector}
          />
        </div>
        <div>
          <Button
            className="add_button me-5"
            variant="contained"
            onClick={() => getPendenciasBySector()}
            disabled={!data.length}
          >
            {language[selectedCountry.name].Dashboard.pecasPendentes.btnAtualizar}
          </Button>
        </div>
      </div>

      <TableContainer
        className="mt-3"
        component={Paper}
      >
        <Table>
          <TableHead>
            <TableRow style={{ backgroundColor: "#f5f5f5" }}>
              <TableCell
                align="center"
                className="row-header"
              >
                {language[selectedCountry.name].Dashboard.pecasPendentes.tableHeader.ordem}
              </TableCell>
              <TableCell
                align="center"
                className="row-header"
              >
                {language[selectedCountry.name].Dashboard.pecasPendentes.tableHeader.editar}
              </TableCell>
              <TableCell
                align="center"
                className="row-header"
              >
                {language[selectedCountry.name].Dashboard.pecasPendentes.tableHeader.setor}
              </TableCell>
              <TableCell
                align="center"
                className="row-header"
              >
                {language[selectedCountry.name].Dashboard.pecasPendentes.tableHeader.peca}
              </TableCell>
              <TableCell
                align="center"
                className="row-header"
              >
                {language[selectedCountry.name].Dashboard.pecasPendentes.tableHeader.veiculo}
              </TableCell>
              <TableCell
                align="center"
                className="row-header"
              >
                {language[selectedCountry.name].Dashboard.pecasPendentes.tableHeader.motivo}
              </TableCell>

              <TableCell
                align="center"
                className="row-header"
              >
                {language[selectedCountry.name].Dashboard.pecasPendentes.tableHeader.status}
              </TableCell>

              <TableCell
                align="center"
                className="row-header"
              >
                {language[selectedCountry.name].Dashboard.pecasPendentes.tableHeader.entrada}
              </TableCell>
              {/* <TableCell
                align="center"
                className="row-header"
              >
                {language[selectedCountry.name].Dashboard.pecasPendentes.tableHeader.setorAtual}
              </TableCell> */}
            </TableRow>
          </TableHead>
          {loading ? (
            <TableBody>
              <TableRow>
                <div className="d-flex justify-content-center align-items-center"
                  style={{ margin: "30px 0px" }}
                >
                  <center>
                    <FontAwesomeIcon icon={faSpinner} spin size="2x" />
                  </center>
                </div>
              </TableRow>
            </TableBody>
          ) : (
            <TableBody>
              {data.length
                ? data.map((item, index) => (
                  <TableRow key={index} >
                    <TableCell
                      className="d-flex justify-content-center row-header"
                      sx={{ cursor: "pointer" }}
                      component="th"
                      scope="row"
                    >
                      <Button
                        onClick={async () => {
                          const header = await getHeader(item.pend_Ordem);
                          setCode(header);
                        }}
                      >
                        {item.pend_Ordem}
                      </Button>
                    </TableCell>
                    <TableCell
                      className="row-header"
                      sx={{ whiteSpace: "nowrap", textAlign: "center" }}
                    >
                      <Button
                        variant="contained"
                        onClick={() => setUpdatePendancy(item)}
                        style={{ height: "30px" }}
                      >
                        <ModeEditOutlineOutlined />
                      </Button>
                    </TableCell>
                    <TableCell
                      className="row-header"
                      sx={{ whiteSpace: "nowrap", textAlign: "center" }}
                    >
                      {item.pend_OrigemSector}
                    </TableCell>
                    <TableCell
                      className="row-header"
                      sx={{ whiteSpace: "nowrap", textAlign: "center" }}
                    >
                      {item.pend_Peca}
                    </TableCell>
                    <TableCell
                      className="row-header"
                      sx={{ whiteSpace: "nowrap", textAlign: "center" }}
                    >
                      {item.pend_DescVeiculo}
                    </TableCell>
                    <TableCell
                      className="row-header"
                      sx={{ whiteSpace: "nowrap", textAlign: "center" }}
                    >
                      {item.pendMot_Descricao}
                    </TableCell>
                    <TableCell
                      className="row-header"
                      sx={{ whiteSpace: "nowrap", textAlign: "center" }}
                    >
                      <span className={`badge bg-${statusColor(item) === "error" ? "danger" : statusColor(item)} text-dark`}>
                        {item.pend_Status}
                      </span>
                    </TableCell>
                    <TableCell
                      className="row-header"
                      sx={{ whiteSpace: "nowrap", textAlign: "center" }}
                    >
                      {DateTimeFmt(item.pend_DataEntrada)}
                    </TableCell>
                    {/* <TableCell
                      className="row-header"
                      sx={{ whiteSpace: "nowrap", textAlign: "center" }}
                    >
                      {item.pend_SetAtual}
                    </TableCell> */}
                  </TableRow>
                ))
                : (
                  <TableRow>
                    <TableCell
                      className="row-header"
                      sx={{ textAlign: "center" }}
                      rowSpan={5}
                    >
                      {!isGetPendencias
                        ? language[selectedCountry.name].Dashboard.pecasPendentes.SelecioneSetor
                        : language[selectedCountry.name].Dashboard.pecasPendentes.setorNaoEncontrado
                      }
                    </TableCell>
                  </TableRow>
                )}
            </TableBody>
          )}
        </Table>
      </TableContainer>
    </div>
  );
}

export default OutstandingPieces;
